// Defers callbacks a frame to suppress benign ResizeObserver loop warnings (triggered by Puck editor internals)
export const createResizeObserverShim = (Base: typeof ResizeObserver): typeof ResizeObserver =>
    class extends Base {
        private readonly targets = new Set<Element>()

        constructor(cb: ResizeObserverCallback) {
            super((entries, observer) => {
                requestAnimationFrame(() => {
                    const observed = entries.filter(entry => this.targets.has(entry.target))
                    if (observed.length) cb(observed, observer)
                })
            })
        }

        observe(target: Element, options?: ResizeObserverOptions) {
            this.targets.add(target)
            super.observe(target, options)
        }

        unobserve(target: Element) {
            this.targets.delete(target)
            super.unobserve(target)
        }

        disconnect() {
            this.targets.clear()
            super.disconnect()
        }
    }
